import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

// interfaces
import { IBillInfo } from 'src/app/core/interfaces/ads/ads-bill-info';

// components
import { OrderDetailsComponent } from 'src/app/shared.standalone/order-details/order-details.component';

@Component({
  standalone: true,
  selector: 'app-bill-data',
  templateUrl: './bill-data.component.html',
  styleUrls: ['./bill-data.component.scss'],
  imports: [ 
    NgIf,
    OrderDetailsComponent
  ]
})
export class BillDataComponent {
  
  /**
   * Inputs
   */

  /**
   *
   */
  @Input({ alias: 'title' }) public title: string = 'رسوم عرض العقار'

  /**
   * 
   */
  @Input({ alias: 'billInfo', required: true }) public billInfo: IBillInfo | undefined  


}
